module.exports = require("./ca-FR.d.ts");